import React from 'react';
import { fr } from '../i18n/fr';

export interface ViewerCountProps {
  count: number | null;
}

/**
 * Viewer count display in the top-left corner (Req 1.14).
 * Shows the current number of viewers via WebSocket.
 * When WebSocket is not connected, displays a dash indicator.
 */
export const ViewerCount: React.FC<ViewerCountProps> = ({ count }) => {
  const displayValue = count !== null ? formatCount(count) : '—';
  const label = count === 1 ? fr.status.viewer : fr.status.viewers;
  const ariaLabel = count !== null ? `${count} ${label}` : 'Nombre de spectateurs indisponible';

  return (
    <div style={styles.container} aria-label={ariaLabel} role="status">
      <EyeIcon />
      <span style={styles.count}>{displayValue}</span>
      {count !== null && <span style={styles.label}>{label}</span>}
    </div>
  );
};

function formatCount(count: number): string {
  if (count >= 1000) {
    return `${(count / 1000).toFixed(1)}k`;
  }
  return count.toString();
}

const EyeIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" style={{ opacity: 0.9 }}>
    <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" />
  </svg>
);

const styles: Record<string, React.CSSProperties> = {
  container: {
    position: 'absolute',
    top: '12px',
    left: '12px',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    padding: '6px 10px',
    borderRadius: '6px',
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    backdropFilter: 'blur(4px)',
    color: '#ffffff',
    fontSize: '0.8rem',
    fontWeight: 500,
    zIndex: 10,
  },
  count: {
    fontWeight: 700,
  },
  label: {
    opacity: 0.8,
  },
};
